import React, { useState } from "react";
import "./Home.css";
import { motion } from "framer-motion";

export default function Home() {
  const openInNewTab = (url) => {
    window.open(url, "_blank");
  };
  const [selectedPage, setselectedPage] = useState("Home");
  return (
    <motion.div
      className="splitScreen"
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1,
        delay: 0.1,
        ease: [0.2, 0.41, 0.91, 1],
      }}
      initial={{ opacity: 0, scale: 0.5 }}
    >
      <div className="leftPane">
        <p className="titleText">About me</p>
        <div className="container">
          <img src="logo.png" width={120} height={120} />
          <div className="centered_text">
            <p>
              Hey, Welcome to my website. I am Younes a Master Degree student in
              computer science. i've been coding since 2018 i've been testing many technologies & programming languages. 
              I develop software in multiple platforms ( Android, Windows, Linux ) or web apps. <br/><strong>Click to download my CV !  </strong>
            </p>
          </div>
          <div className="centered_button_cv">
            <a href="cv.pdf" className="downloadCv">
              {/*<!--download cv here replace pdf.png-->*/}
              <img className="resp_img" src="pdf.png" width={30} height={30} />
              <p className="contactText">Download CV</p>
            </a>
          </div>
        </div>
      </div>

      <div className="rightPane">
        <p className="titleText">Contact</p>

        <div className="secondContainer">
          <a
            href="https://www.linkedin.com/in/younes-haddam-754b5019b/"
            className="grow_skew_forward"
          >
            <img
              className="resp_img"
              src="linkedin.png"
              width={30}
              height={30}
            />
            <p className="contactText">Younes HADDAM</p>
          </a>
          <a href="link address" className="grow_skew_forward">
            <img className="resp_img" src="mail.png" width={30} height={30} />
            <p className="contactText">haddamyounes5@gmail.com</p>
          </a>
          <a href="link address" className="grow_skew_forward">
            <img className="resp_img" src="phone.png" width={30} height={30} />
            <p className="contactText">+33666631454</p>
          </a>
          <a href="https://github.com/Younext19" className="grow_skew_forward">
            <img className="resp_img" src="github.png" width={30} height={30} />
            <p className="contactText">@Younext19</p>
          </a>

          <a
            href="https://stackoverflow.com/users/10676758/younextadams"
            className="grow_skew_forward"
          >
            <img className="resp_img" src="stack.png" width={30} height={30} />
            <p className="contactText">YounextAdams</p>
          </a>
        </div>
      </div>
    </motion.div>
  );
}
